module.exports = __webpack_public_path__ + "static/img/27.4e060da5.jpg";